<h2 class="email">{{ userBloc.existingUserEmail$ | async }}</h2>
